module.exports = __webpack_public_path__ + "static/media/waterBackground.30a6cb04.svg";